import * as React from "react";
import type { SVGProps } from "react";
const SvgFileReturn02 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M10.5 21.6h-6a2.4 2.4 0 0 1-2.4-2.4V4.8a2.4 2.4 0 0 1 2.4-2.4h10.8a2.4 2.4 0 0 1 2.4 2.4v4.8M6.3 7.2h7.2m-7.2 3.6h7.2m-7.2 3.6h3.6m5.443 6L12.9 17.946m0 0 2.332-2.346M12.9 17.946h7.227a1.773 1.773 0 0 0 0-3.546H17.7"
    />
  </svg>
);
export default SvgFileReturn02;
